import React, { Fragment } from 'react';

import { useQuery } from '@tanstack/react-query';
import { Link } from '~/lib/react-router-dom';

import { Button, CircularProgress } from '@mui/material';

import { getPartnerships } from '~/services/LoyaltyService';

import getEarnOrderPartnerships from '~/utils/getEarnOrderPartnerships';

type Props = {
  user: App.User;
};

const loyaltyPageUri = (userId: string, code: string) => {
  return `/users/${userId}/loyalty/${code}`;
};

export default function PartnershipButtons({ user }: Props) {
  const { data: partnerships = [], isLoading } = useQuery<Array<App.Partnership>, Error>({
    queryKey: ['partnerships', 'earnOrder'],
    queryFn: async () => {
      const response = await getPartnerships();
      return getEarnOrderPartnerships(response.result);
    },
  });

  if (isLoading) {
    return <CircularProgress size="24px" />;
  }

  return (
    <>
      {partnerships.map((partnership: App.Partnership) => (
        <Fragment key={partnership.code}>
          <Button
            component={Link}
            className="T-view-qantas-btn"
            variant="contained"
            to={loyaltyPageUri(user.id_member, partnership.code)}
          >
            {partnership.brandName}
          </Button>
        </Fragment>
      ))}
    </>
  );
}
